import React from 'react';
import alertIcon from '../../assets/alert.svg';
import './alert.scss';
const Alert = (props) => {
  const { message } = props;

  return (
    <div className="alerts">
      <div className="alert alert-danger">
        <div className="icon">
          <img
            src={alertIcon}
            width={32}
            height={32}
            alt="Logo"
            className="logo"
          />
        </div>
        <div className="message">
          <strong>Oops!</strong>
          <p>{message}</p>
        </div>
      </div>
    </div>
  );
};

export default Alert;
